import { typeOption } from '../constants/parameterTypes';
import { paramType } from '../constants/parameterNames';
import { failure } from '../helpers/commandResult';
import promptBox, { PROMPTBOX_RESULT_CANCEL, PROMPTBOX_TYPE_OK, PROMPTBOX_TYPE_OKCANCEL, PROMPTBOX_TYPE_YESNO, PROMPTBOX_TYPE_YESNOCANCEL } from '../../UI/promptBox';

const promptTitle = "title";
const promptText = "text";
const promptYesText = "yestext";
const promptNoText = "notext";
const promptOkText = "oktext";
const promptCancelText = "canceltext";

const optionalParameters = [
    {
        name: promptTitle,
        description: "The title on the prompt (defaults to blank)."
    },
    {
        name: promptText,
        description: "The text on the popup (defaults to blank)."
    },
    {
        name: paramType,
        description: "Type of prompt to make (available options are YesNo, YesNoCancel, and OKCancel - defaults to YesNo).",
        type: typeOption,
        options: [
            {
                name: "YesNo",
                value: PROMPTBOX_TYPE_YESNO,
            },
            {
                name: "YesNoCancel",
                value: PROMPTBOX_TYPE_YESNOCANCEL,
            },
            {
                name: "OKCancel",
                value: PROMPTBOX_TYPE_OKCANCEL,
            },
            {
                name: "OK",
                value: PROMPTBOX_TYPE_OK,
            }
        ]
    },
    {
        name: promptYesText,
        description: "The text to show on the Yes button (defaults to Yes)."
    },
    {
        name: promptNoText,
        description: "The text to show on the No button (defaults to No)."
    },
    {
        name: promptOkText,
        description: "The text to show on the OK button (defaults to OK)."
    },
    {
        name: promptCancelText,
        description: "The text to show on the Cancel button (defaults to Cancel)."
    },
];

const description = "Prompts the user with a popup dialog and produces a result based on the user's selection";

const Prompt = (params) => {

    const executeAsync = async () => {

        const cf = params.commonFunctions;

        const dialog = promptBox({
            title: cf.getParamValue(promptTitle),
            text: cf.getParamValue(promptText),
            type: cf.getParamValue(paramType, PROMPTBOX_TYPE_YESNO),
            yesText: cf.getParamValue(promptYesText, "Yes"),
            noText: cf.getParamValue(promptNoText, "No"),
            okText: cf.getParamValue(promptOkText, "OK"),
            cancelText: cf.getParamValue(promptCancelText, "Cancel")
        });

        try {
            const result = await dialog.showAsync();

            return result === PROMPTBOX_RESULT_CANCEL
                ? ''
                : result.toString();

        } catch (e) {
            return failure("Failed to create prompt: " + (e.message));
        }
    }

    return {
        description,
        optionalParameters,
        executeAsync,
    };
}

export default Prompt;